export default "__VITE_ASSET__DvU_gBC0__"